import { Injectable } from '@angular/core';

import { checkMetrika, initMetrika, loadMetrikaScript } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class MetrikaService {
  private id = '';

  init(id: string) {
    this.id = id;

    loadMetrikaScript(id);

    initMetrika(id);
  }

  check() {
    if (!!this.id) {
      checkMetrika(this.id);
    }
  }
}
